import React, { useMemo, useState } from 'react'
import { generatePublicUrl } from '../urlConfig'
import Loader from './Loader'
import DeleteIcon from '@mui/icons-material/Delete'
import SettingsIcon from '@mui/icons-material/Settings'
import { useDispatch } from 'react-redux'
import { updateProductPriceVisibleById, updateProductVisibleById, createQRCodeById } from './../actions/product.action'
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import MoneyOffIcon from '@mui/icons-material/MoneyOff'
import Tooltip from '@mui/material/Tooltip'
import ViewInArIcon from '@mui/icons-material/ViewInAr'
import Checkbox from '@mui/material/Checkbox'
import TextViews from './TextViews'
import QrCodeIcon from '@mui/icons-material/QrCode'
import ExtensionIcon from '@mui/icons-material/Extension'
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing'
import VisibleIconComponent from './VisibleIconComponent'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import ContainerButtonVisible from './ContainerButtonVisible'

const RenderFileContainer = (props) => {
    const {
        setShowSettingCategoryModal,
        handleShowMaterialModal,
        setShowDeleteModal,
        showSettingModal,
        showDetailsModal,
        setCurrentId,
        categoryObj,
        setDeleteId,
        visibilityFilter = 'all',
        setVisibilityFilter,
        fileView,
        loading,
        setShow,
        items,
        slug,
    } = props

    const dispatch = useDispatch()
    const [openMenu, setOpenMenu] = useState(null)

    const filteredProducts = useMemo(() => {
        const source = Array.isArray(items) ? items : []

        if (visibilityFilter === 'visible') {
            return source.filter((item) => Boolean(item.visibleProduct))
        }

        if (visibilityFilter === 'hidden') {
            return source.filter((item) => !item.visibleProduct)
        }

        return source
    }, [items, visibilityFilter])

    const handleShowSettingModal = () => {
        setShowSettingCategoryModal(true)
    }

    const renderMainTitle = () => {
        const title = slug === 'all'
            ? 'Все товары'
            : categoryObj?.name || 'Товары'

        return (
            <div className="product__renderTitleNameCategory">
                <div className="product__categoryTitle">
                    <h1>{title}</h1>

                    {slug !== 'all' && categoryObj ? (
                        <button
                            type="button"
                            className="product__categorySettingsBtn"
                            onClick={handleShowSettingModal}
                            aria-label={`Настройки категории ${title}`}
                            title="Настройки категории"
                        >
                            <SettingsIcon />
                        </button>
                    ) : null}
                </div>

                <ContainerButtonVisible
                    value={visibilityFilter}
                    onChange={setVisibilityFilter}
                />
            </div>
        )
    }

    const handleVisibleProduct = (id) => {
        dispatch(updateProductVisibleById(id, slug, visibilityFilter))
    }

    const handleVisibleProductPrice = (id) => {
        dispatch(updateProductPriceVisibleById(id, slug, visibilityFilter))
    }

    const Edit = (item) => {
        setCurrentId(item._id)
        setShow(true)
    }

    const confirmDeletions = (item) => {
        setDeleteId(item._id)
        setShowDeleteModal(true)
    }

    const createQRCode = (item, typeModal) => {
        if (item.QRCodePicture) {
            showDetailsModal(item, typeModal)
            return
        }

        dispatch(createQRCodeById(item._id))
    }

    if (loading) return <Loader />
    if (!items) return null

    const renderEmpty = () => (
        <div className="renderEmptyItem">
            <h3>Товаров по выбранному фильтру пока нет</h3>
            <div className="renderEmptyItem__buttonContainer">
                <button
                    type="button"
                    onClick={() => setVisibilityFilter?.('all')}
                >
                    Показать все товары
                </button>
            </div>
        </div>
    )

    if (fileView === 'plate') {
        return (
            <div className="fileplate">
                {renderMainTitle()}

                {filteredProducts.length === 0
                    ? renderEmpty()
                    : filteredProducts.map((item) => (
                        <div
                            className={!item.visibleProduct ? 'file-plate hideProduct' : 'file-plate'}
                            key={item._id}
                        >
                            <div className="file-plate__imgContainer">
                                <img
                                    onClick={() => showDetailsModal(item, 'details')}
                                    className="file__img"
                                    src={generatePublicUrl(
                                        item.productPictures
                                            ? item.reducedImage
                                            : item.images?.[0]?.img
                                    )}
                                    alt={item.name}
                                />
                            </div>

                            <div className="file-plate__name">
                                {item.title
                                    ? item.title
                                    : item.fullName !== ''
                                        ? item.fullName
                                        : 'Не указано'}
                            </div>

                            <div className="file-plate__btns">
                                <button
                                    type="button"
                                    className="file-plate__buttons setting"
                                    onClick={() => Edit(item)}
                                    aria-label="Редактировать товар"
                                >
                                    <SettingsIcon />
                                </button>
                                <button
                                    type="button"
                                    className="file-plate__buttons delete"
                                    onClick={() => confirmDeletions(item)}
                                    aria-label="Удалить товар"
                                >
                                    <DeleteIcon />
                                </button>
                            </div>
                        </div>
                    ))}
            </div>
        )
    }

    return (
        <div className="files" onClick={() => setOpenMenu(null)}>
            {renderMainTitle()}

            {filteredProducts.length === 0
                ? renderEmpty()
                : filteredProducts.map((item) => (
                    <div
                        className={!item.visibleProduct ? 'file hideProduct' : 'file'}
                        key={item._id}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="file__actions">
                            <button
                                type="button"
                                className="file__moreBtn"
                                onClick={(e) => {
                                    e.stopPropagation()
                                    setOpenMenu(openMenu === item._id ? null : item._id)
                                }}
                                aria-expanded={openMenu === item._id}
                            >
                                <MoreVertIcon />
                            </button>

                            {openMenu === item._id && (
                                <div
                                    className="file__actionsMenu"
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    <div className="file__menuRow">
                                        <Checkbox color="primary" value={item._id} />
                                        <span>Выбрать</span>
                                    </div>

                                    <button
                                        type="button"
                                        className="file__menuItem"
                                        onClick={() => showDetailsModal(item, 'updatedPictures')}
                                    >
                                        <PrecisionManufacturingIcon />
                                        <span>3D и фото</span>
                                    </button>

                                    <button
                                        type="button"
                                        className="file__menuItem"
                                        onClick={() => showSettingModal(item)}
                                    >
                                        <SettingsIcon />
                                        <span>Настройки видимости</span>
                                    </button>

                                    <button
                                        type="button"
                                        className="file__menuItem"
                                        onClick={() => handleShowMaterialModal(item)}
                                    >
                                        <ViewInArIcon />
                                        <span>Материалы</span>
                                    </button>

                                    <button
                                        type="button"
                                        className="file__menuItem"
                                        onClick={() => createQRCode(item, 'QRCode')}
                                    >
                                        <QrCodeIcon />
                                        <span>
                                            {item.QRCodePicture
                                                ? 'Показать QR'
                                                : 'Сгенерировать QR'}
                                        </span>
                                    </button>

                                    <div className="file__menuItem">
                                        <VisibleIconComponent
                                            handleClick={handleVisibleProduct}
                                            itemId={item._id}
                                            itemVisible={item.visibleProduct}
                                            text="товар"
                                        />
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="file__mainContainer">
                            <div className={`file__containerImg ${item.updatedPictures ? 'updatedPictures' : ''}`}>
                                <img
                                    className="file__img"
                                    onClick={() => showDetailsModal(item, 'details')}
                                    src={
                                        item.productPictures
                                            ? generatePublicUrl(item.reducedImage)
                                            : generatePublicUrl(item.images?.[0]?.img)
                                    }
                                    alt={item.title ? item.title : item.name}
                                />
                                <div className="file__timeBlock">
                                    Товар был добавлен: {`${item.createdAt.slice(0, 10)} ${item.createdAt.slice(11, 19)}`}
                                </div>
                            </div>

                            <div className="file__mainContentContainer">
                                <div className="file__contentBox">
                                    <div className="file__name">
                                        {item.fullName !== '' ? item.fullName : 'Не указано'}
                                    </div>

                                    <TextViews itemViews={item.viewsLength} />

                                    <Tooltip
                                        onClick={() => showDetailsModal(item, 'production')}
                                        title="Производство"
                                    >
                                        <ExtensionIcon />
                                    </Tooltip>
                                </div>

                                <div className="file__mainPriceContainer">
                                    <div
                                        className="file__visibleIconBlock"
                                        onClick={() => handleVisibleProductPrice(item._id)}
                                    >
                                        {item.visiblePrice
                                            ? (
                                                <Tooltip title="Скрыть цену">
                                                    <AttachMoneyIcon />
                                                </Tooltip>
                                            )
                                            : (
                                                <Tooltip title="Отобразить цену">
                                                    <MoneyOffIcon />
                                                </Tooltip>
                                            )}
                                    </div>

                                    {item.visiblePrice
                                        ? <div className="file__price">{item.price}</div>
                                        : <div className="file__price">Скрыто</div>}
                                </div>

                                <div className="file__size" />
                            </div>

                            <div className="file__buttonContainer">
                                <button
                                    type="button"
                                    className="file__btn file__download"
                                    onClick={() => Edit(item)}
                                >
                                    Редактировать
                                </button>
                                <button
                                    type="button"
                                    className="file__btn file__delete"
                                    onClick={() => confirmDeletions(item)}
                                >
                                    Удалить
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
        </div>
    )
}

export default RenderFileContainer
